import type { PeriodoEntrega } from "../models/periodoEntregaFornecedorModel"

export enum PeriodoEntregaFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
    ADICIONAR_PERIODO = "ADICIONAR_PERIODO",
    ATUALIZAR_PERIODO = "ATUALIZAR_PERIODO",
    REMOVER_PERIODO = "REMOVER_PERIODO",
    ATUALIZAR_STATUS = "ATUALIZAR_STATUS",
}

export type PeriodoEntregaFornecedorActionModel =
    | {
          type: PeriodoEntregaFornecedorActionsTypes.CARREGAR
          payload: { periodos: PeriodoEntrega[]; statusDelivery: number }
      }
    | {
          type: PeriodoEntregaFornecedorActionsTypes.ADICIONAR_PERIODO
          payload: PeriodoEntrega
      }
    | {
          type: PeriodoEntregaFornecedorActionsTypes.ATUALIZAR_PERIODO
          payload: PeriodoEntrega
      }
    | {
          type: PeriodoEntregaFornecedorActionsTypes.REMOVER_PERIODO
          payload: number
      }
    | {
          type: PeriodoEntregaFornecedorActionsTypes.ATUALIZAR_STATUS
          payload: number
      }
